<template>
    <div class="">
        
        <template>
            <the-header />
        </template>

        <div class="site-wrapper-reveal">
            <div class="about-banner-wrap banner-space about-us-bg position-relative">
                <div class="banner-overlay"></div>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-8 ml-auto mr-auto">
                            <div class="about-banner-content text-center">
                                <h1 class="mb-15 text-white">Testimonials</h1>
                                <h5 class="font-weight--normal text-white">Proven 15 years’ track record in property management. </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="testimonial-slider-area section-space--ptb_120">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="section-title-wrap text-center section-space--mb_40">
                                <h6 class="section-sub-title mb-8">Testimonials</h6>
                                <h3 class="heading">Why do people <span class="text-color-primary">Love Axis Realty Group?</span></h3>
                            </div>
                            <div class="testimonial-slider">
                                <div class="swiper-container testimonial-slider__container">
                                    <swiper :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
                                        <swiper-slide>
                                            <div class="testimonial-slider__one wow move-up">

                                                <div class="testimonial-slider--info">

                                                    <div class="testimonial-slider__author">
                                                        <div class="testimonial-rating">
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                        </div>
                                                        <div class="author-info">
                                                            <h6 class="name">Resident Testimonial</h6>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="testimonial-slider__text">
                                                    I was really impressed with the service I received from the property agents. Their
                                                    representative was were very friendly and eager to help right from viewing the properties to
                                                    the signing of the lease. Needless to say, they helped me find the ideal apartment, and I&#39;m
                                                    now comfortably settled in.
                                                </div>

                                            </div>
                                        </swiper-slide>
                                        <swiper-slide>
                                            <div class="testimonial-slider__one wow move-up">

                                                <div class="testimonial-slider--info">

                                                    <div class="testimonial-slider__author">
                                                        <div class="testimonial-rating">
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                        </div>
                                                        <div class="author-info">
                                                            <h6 class="name">Resident Testimonial</h6>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="testimonial-slider__text">
                                                    I really like the place I’m renting from Axis. It is well taken care of and has all the amenities.
                                                </div>

                                            </div>
                                        </swiper-slide>
                                        <swiper-slide>
                                            <div class="testimonial-slider__one wow move-up">

                                                <div class="testimonial-slider--info">

                                                    <div class="testimonial-slider__author">
                                                        <div class="testimonial-rating">
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                        </div>
                                                        <div class="author-info">
                                                            <h6 class="name">Resident Testimonial</h6>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="testimonial-slider__text">
                                                    Axis property agents were quite prompt in answering all my queries about the rental before
                                                    I moved and were very professional with all the due diligence.
                                                </div>

                                            </div>
                                        </swiper-slide>
                                        <swiper-slide>
                                            <div class="testimonial-slider__one wow move-up">

                                                <div class="testimonial-slider--info">

                                                    <div class="testimonial-slider__author">
                                                        <div class="testimonial-rating">
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                        </div>
                                                        <div class="author-info">
                                                            <h6 class="name">Resident Testimonial</h6>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="testimonial-slider__text">
                                                    As a landlord using Axis Realty as my agent, I’ve found their services to be stellar. Their
                                                    remittances are timely, and they keep the place well maintained.
                                                </div>

                                            </div>
                                        </swiper-slide>
                                        <swiper-slide>
                                            <div class="testimonial-slider__one wow move-up">

                                                <div class="testimonial-slider--info">

                                                    <div class="testimonial-slider__author">
                                                        <div class="testimonial-rating">
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                        </div>
                                                        <div class="author-info">
                                                            <h6 class="name">Resident Testimonial</h6>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="testimonial-slider__text">
                                                    Axis have a very professional staff. They were available for the property showing even on the
                                                    weekend and were very patient with my questions.
                                                </div>

                                            </div>
                                        </swiper-slide>
                                        <swiper-slide>
                                            <div class="testimonial-slider__one wow move-up">

                                                <div class="testimonial-slider--info">

                                                    <div class="testimonial-slider__author">
                                                        <div class="testimonial-rating">
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                        </div>
                                                        <div class="author-info">
                                                            <h6 class="name">Resident Testimonial</h6>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="testimonial-slider__text">
                                                    These guys are real professionals. Worked round the clock to find me a place to stay on
                                                    short notice and were friendly and personable all the time. Thanks.
                                                </div>

                                            </div>
                                        </swiper-slide>
                                        <swiper-slide>
                                            <div class="testimonial-slider__one wow move-up">

                                                <div class="testimonial-slider--info">

                                                    <div class="testimonial-slider__author">
                                                        <div class="testimonial-rating">
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                        </div>
                                                        <div class="author-info">
                                                            <h6 class="name">Resident Testimonial</h6>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="testimonial-slider__text">
                                                    They’ve got good, professional agents working for them to help tenants find a great place to
                                                    live. A very satisfied customer here.
                                                </div>

                                            </div>
                                        </swiper-slide>
                                        <swiper-slide>
                                            <div class="testimonial-slider__one wow move-up">

                                                <div class="testimonial-slider--info">

                                                    <div class="testimonial-slider__author">
                                                        <div class="testimonial-rating">
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                            <feather-icon icon="StarIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                        </div>
                                                        <div class="author-info">
                                                            <h6 class="name">Resident Testimonial</h6>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="testimonial-slider__text">
                                                    As a tenant living in their property, I am happy with their service. They maintain the
                                                    apartments and groundswell and respond to tenant issues on time.
                                                </div>

                                            </div>
                                        </swiper-slide>
                                        <div class="swiper-pagination swiper-pagination-project mt_20" slot="pagination"></div>
                                    </swiper>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
            
        <the-footer />
    </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import TheHeader   from '@/layouts/components/TheHeader.vue'
import TheFooter   from '@/layouts/components/TheFooter.vue'

export default {
  components: {
    TheHeader,
    TheFooter,
    swiper,
    swiperSlide
  },
  data () {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 0,
        // init: false,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 40
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20
          }
        }
      }
    }
  }

}
</script>